import $ from "jquery";

function PasswordVisibility() {
  $(".js-password-button").on("click", function (e) {
    e.preventDefault();

    const pass = $(this).closest(".js-password");
    const input = pass.find(".js-password-input");

    if (input.attr("type") === "password") {
      pass.addClass("is-visible");
      input.attr("type", "text");
      $(this).text("隠す");
    } else {
      pass.removeClass("is-visible");
      input.attr("type", "password");
      $(this).text("表示する");
    }
  });
}

export { PasswordVisibility };
